import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/home/index.vue";
import MiningView from "../views/mining/index.vue";
import RecordView from "../views/mining/record.vue";
import WalletView from "../views/wallet/index.vue";
import WithdrawView from "../views/wallet/withdraw.vue";
import MeView from "../views/me/index.vue";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        component: HomeView,
        meta: { name: "home" }
      },
      {
        path: "/mining",
        name: "mining",
        component: MiningView,
        meta: { name: "mining" }
      },
      {
        path: "/record",
        name: "record",
        component: RecordView,
        meta: { name: "record" }
      },
      {
        path: "/wallet",
        name: "wallet",
        component: WalletView,
        meta: { name: "wallet" }
      },
      
      {
        path: "/withdraw",
        name: "withdraw",
        component: WithdrawView,
        meta: { name: "withdraw" }
      },
      {
        path: "/me",
        name: "me",
        component: MeView,
        meta: { name: "me" }
      },
    ],
  },
];

// 保存原始方法
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写 push 方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 处理重复路由跳转的错误
    if (err.name !== 'NavigationDuplicated') {
      // 如果不是重复跳转错误，将错误继续抛出
      throw err;
    }
  });
};

// 重写 replace 方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.afterEach(() => {
  // 平滑滚动到顶部（兼容大部分浏览器）
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})
export default router;
